import { FriendlyCaptchaSDK, WidgetHandle } from '@friendlycaptcha/sdk';
import React, { Component } from 'react';

interface FriendlyCaptchaProps {
  ref: React.RefObject<FriendlyCaptcha | null>;
  callbackDone: (solution: string) => any;
}

// One SDK instance per page, shared by all widgets (created lazily, client only)
let sdk: FriendlyCaptchaSDK | null = null;
const getSdk = () => {
  if (!sdk) {
    sdk = new FriendlyCaptchaSDK({ apiEndpoint: 'eu' });
  }
  return sdk;
};

class FriendlyCaptcha extends Component<FriendlyCaptchaProps> {
  container = React.createRef<HTMLDivElement>();
  widget: WidgetHandle | null = null;

  componentDidMount() {
    if (!this.widget && this.container.current) {
      // widget.destroy() removes the mount element, so it must not be owned by React
      const element = document.createElement('div');
      element.className = 'frc-captcha';
      this.container.current.appendChild(element);

      this.widget = getSdk().createWidget({
        element,
        sitekey: process.env.NEXT_PUBLIC_FRIENDLY_CAPTCHA_SITEKEY,
        language: 'de',
        startMode: 'focus',
        // The response is sent to our API via callbackDone, not as a form field
        formFieldName: null,
      });
      this.widget.addEventListener('frc:widget.complete', (event) => {
        this.props.callbackDone(event.detail.response);
      });
      this.widget.addEventListener('frc:widget.expire', () => {
        this.props.callbackDone('');
      });
      this.widget.addEventListener('frc:widget.reset', () => {
        this.props.callbackDone('');
      });
      this.widget.addEventListener('frc:widget.error', (event) => {
        console.info('There was an error when trying to solve the Captcha.');
        console.error(event.detail.error);
      });
    }
  }

  public resetCaptcha() {
    if (this.widget) {
      this.widget.reset();
    }
  }

  componentWillUnmount() {
    if (this.widget) {
      this.widget.destroy();
      this.widget = null;
    }
  }

  render() {
    return <div ref={this.container} className="GameForm__captcha" />;
  }
}

export default FriendlyCaptcha;
